import apiService from './apiService';

const PREFIX = '/admin/client-mappings';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const clientMappingService = {
  async list({ status = null, q = '', limit = 200 } = {}) {
    const data = await request(apiService.get(PREFIX, { status, q, limit }));
    return Array.isArray(data.mappings) ? data.mappings : [];
  },

  async autoMatch({ refreshDrive = true } = {}) {
    const data = await request(apiService.post(
      `${PREFIX}/auto-match`,
      { refresh_drive: refreshDrive },
      {},
      { timeout: 300000 },
    ));
    return data.stats || {};
  },

  async listOrphans({ limit = 200 } = {}) {
    return request(apiService.get(`${PREFIX}/orphans`, { limit }));
  },

  async searchDolibarr(q, limit = 15) {
    const data = await request(apiService.get(`${PREFIX}/dolibarr-search`, { q, limit }));
    return Array.isArray(data.thirdparties) ? data.thirdparties : [];
  },

  async validate(id) {
    const data = await request(apiService.post(`${PREFIX}/${id}/validate`));
    return data.mapping;
  },

  async ignore(id) {
    const data = await request(apiService.post(`${PREFIX}/${id}/ignore`));
    return data.mapping;
  },

  async update(id, body) {
    const data = await request(apiService.put(`${PREFIX}/${id}`, body));
    return data.mapping;
  },

  async create(body) {
    const data = await request(apiService.post(PREFIX, body));
    return data.mapping;
  },

  async remove(id) {
    return request(apiService.delete(`${PREFIX}/${id}`));
  },
};

export default clientMappingService;
